import React, { useState, useEffect } from 'react';
import socketService from '../services/socketService';
import Layout from '../components/Layout';

const ChangePassword = () => {
    // --- States ---
    const [password, setPassword] = useState('');
    const [confirmPassword, setConfirmPassword] = useState('');
    const [loading, setLoading] = useState(false);
    const [message, setMessage] = useState(null);
    const [error, setError] = useState(null);

    // 🔐 লগইন করা অ্যাডমিনের আইডি লোকাল স্টোরেজ থেকে নেওয়া হচ্ছে
    const adminId = localStorage.getItem('adminId2');

    useEffect(() => {
        // সকেট কানেকশন চেক
        const socket = socketService.getSocket();
        if (!socket || !socket.connected) {
            socketService.connect();
        }

        // সার্ভার থেকে রেসপন্স হ্যান্ডল করা
        const handleResponse = (data) => {
            setLoading(false);
            if (data.success) {
                setMessage('✅ পাসওয়ার্ড সফলভাবে পরিবর্তন হয়েছে!');
                setPassword('');
                setConfirmPassword('');
                setError(null);
                
                // ৩ সেকেন্ড পর মেসেজ সরিয়ে ফেলা
                setTimeout(() => setMessage(null), 3000);
            } else {
                setError(`❌ ত্রুটি: ${data.message || 'পাসওয়ার্ড পরিবর্তন করা যায়নি।'}`);
                setMessage(null);
            }
        };

        // admin-edit-response ইভেন্ট লিসেন করা
        socketService.on('admin-edit-response', handleResponse);

        return () => {
            socketService.off('admin-edit-response', handleResponse);
        };
    }, []);

    const handleSubmit = (e) => {
        e.preventDefault();
        setError(null);
        setMessage(null);

        // ভ্যালিডেশন
        if (!password || !confirmPassword) {
            setError("⚠️ সব ফিল্ড পূরণ করা আবশ্যক।");
            return;
        }
        if (password.length < 6) {
            setError("⚠️ পাসওয়ার্ড কমপক্ষে ৬ অক্ষরের হতে হবে।");
            return;
        }
        if (password !== confirmPassword) {
            setError("❌ পাসওয়ার্ড মিলছে না!");
            return;
        }
        if (!adminId) {
            setError("❌ অ্যাডমিন আইডি পাওয়া যায়নি। দয়া করে পুনরায় লগইন করুন।");
            return;
        }

        setLoading(true);

        // 🔥 সার্ভারে রিকোয়েস্ট পাঠানো (আপনার অরিজিনাল লজিক)
        socketService.emit('admin-edit', {
            id: adminId,      
            password: password 
        });
    };

    return (
        <Layout>
            <div className="main-content-area p-4 min-vh-100">
                
                {/* 🔥 পরিবর্তন: Top View করার জন্য pt-5 (padding-top) দেওয়া হয়েছে এবং align-items-center বাদ দেওয়া হয়েছে */}
                <div className="d-flex justify-content-center pt-5">
                    <div className="filter-card shadow-sm border-0 p-4" style={{ maxWidth: '450px', width: '100%', borderTop: '4px solid #0284c7' }}>
                        
                        <div className="text-center mb-4">
                            <h5 className="section-title m-0" style={{ fontSize: '18px' }}>🔒 Change Password</h5>
                            <p className="text-muted small mt-2">আপনার অ্যাকাউন্টের জন্য নতুন পাসওয়ার্ড সেট করুন</p>
                        </div>

                        {message && <div className="alert bg-seen border-0 mb-3 small fw-bold text-center">{message}</div>}
                        {error && <div className="alert bg-fake border-0 mb-3 small fw-bold text-center" style={{ color: '#dc2626' }}>{error}</div>}

                        <form onSubmit={handleSubmit}>
                            <div className="mb-3">
                                <label className="field-label mb-2">NEW PASSWORD</label>
                                <input 
                                    type="password" 
                                    className="modern-input" 
                                    placeholder="Enter new password" 
                                    value={password}
                                    onChange={(e) => setPassword(e.target.value)}
                                    disabled={loading}
                                />
                            </div>

                            <div className="mb-4">
                                <label className="field-label mb-2">CONFIRM PASSWORD</label>
                                <input 
                                    type="password" 
                                    className="modern-input" 
                                    placeholder="Confirm new password" 
                                    value={confirmPassword}
                                    onChange={(e) => setConfirmPassword(e.target.value)}
                                    disabled={loading}
                                />
                            </div>

                            <button 
                                type="submit" 
                                className="btn btn-apply fw-bold w-100 py-2" 
                                style={{ fontSize: '14px' }}
                                disabled={loading}
                            >
                                {loading ? 'Updating...' : 'Update Password'}
                            </button>
                        </form>
                    </div>
                </div>
            </div>

            {/* CSS Styles */}
            <style>{`
                .main-content-area { background-color: #f4f7fa; font-family: 'Inter', sans-serif; }
                .section-title { color: #334155; font-weight: 700; }
                .filter-card { background: #ffffff; border-radius: 12px; }
                .field-label { font-size: 11px; font-weight: 700; color: #64748b; text-transform: uppercase; }
                .modern-input { background: #f8fafc; border: 1px solid #cbd5e1; padding: 10px 15px; border-radius: 8px; font-size: 14px; width: 100%; outline: none; transition: 0.2s; }
                .modern-input:focus { border-color: #0284c7; background: #fff; }
                .btn-apply { background: #0284c7; color: white; border-radius: 8px; border: none; transition: 0.3s; }
                .btn-apply:hover { background: #0369a1; }
                .bg-seen { background: #f0fdf4; color: #16a34a; border-color: #bbf7d0; }
                .bg-fake { background: #fee2e2; border-color: #fecaca; }
            `}</style>
        </Layout>
    );
};

export default ChangePassword;